import React from "react"
import { Modal, ModalFooter } from "react-bootstrap"
import { Button } from "../../../components"
import { toast } from "react-toastify"
import { AssociateRescheduleCancelSlots } from "../../../utilities/api/associateBooking"

const AssociateRescheduleCancelModal = (props: any) => {
    const { showCancelModal, handleCloseCancel, GetData, cancelPayload, setCancelPayload, id } = props

    const handleSubmit = async () => {
        let result = await AssociateRescheduleCancelSlots(id, cancelPayload)
        if (result?.status === 200) {
            handleCloseCancel()
            setCancelPayload({
                cancelType: "daywiseOuter",
                bookingDay: "",
                startTime: "",
                endTime: "",
                slotId: ""
            })
            GetData()
            toast.success(result?.data.message)
        } else {
            toast.error(result?.response.data.message);
        }
    }

    return (
        <Modal show={showCancelModal} onHide={handleCloseCancel} centered>
            <Modal.Header className="border-0 pb-0 pb-2" closeButton>
                <Modal.Title id="contained-modal-title-vcenter fw-semibold">Remarks</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Cancelling the day will Cancel all the bookings of this Associate Aligned for this day. Do you want to Cancel?</p>
                <ModalFooter className="justify-center">
                    <div className="">
                        <Button onClick={handleSubmit} type="button" bname="Yes" name="yes" id="yes" className="btn btn-primary rounded-1 mt-1 me-3"></Button>
                        <Button onClick={handleCloseCancel} type="button" bname="No" name="no" id="no" className="btn btn-light rounded-1 mt-1"></Button>
                    </div>
                </ModalFooter>
            </Modal.Body>
        </Modal>
    )
}

export { AssociateRescheduleCancelModal }